import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getProfiles = (filters, token) => {
    return axios({
        method: 'get',
        url: `${api}/profiles`,
        headers: {
            ...headers,
            "X-Access-Token": token
        }
    }).then(response => {
        
        return response;
    });
};
